import { useEffect, useState } from "react";
import AddIcon from "assets/svgIcons/AddIconWithCircle";
import IconButton from "@mui/material/IconButton";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreNormalIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import {
    ItemRow,
    ItemsWrapper,
} from "pages/FoodAndBeverages/FBSettings/FoodAndBeveragesStyled";
import FoodImagePopup from "./FoodImagePopup";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isUserBasic, isUserReadOnly } from "constant";
import { formatNumber } from '../../Util/Accounting';
import {
    API_CALLS
} from "redux/reduxToolkitServices/_commonApiCalls/api";
import { headersConfigData } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";

const AddItem = ({
    handleOnDelete,
    i,
    index,
    listType,
    DummyFoodImage,
    subChild,
    addSubchild,
    handleOnDeleteSubChild,
    data,
    handleOnChangeTitle,
    handleOnChangePrice,
    shiftUpSubChild,
    expandSubGroup,
    toggleAcordionSubGroup,
    foodDetails,
    shiftUpDownChild,
    parentIndex,
    list,
    setList,
    setIsSaveMenuDisabled
}) => {
    const { t } = useTranslation();
    const { siteSettingsData, getUserRole } = useSelector((state) => state.commonReducers) || [];
    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState(foodDetails?.group?.child?.[index].title || foodDetails?.group?.child?.[index].title === "" ? foodDetails?.group?.child?.[index].title : foodDetails?.item?.child?.[index].title)
    const [price, setPrice] = useState(foodDetails?.group?.child?.[index].price || foodDetails?.group?.child?.[index].price === "0.00" ? formatNumber(foodDetails?.group?.child?.[index].price, siteSettingsData.CurrencyThousandsSeparator, siteSettingsData.CurrencyDecimalSeparator) : formatNumber(foodDetails?.item?.child?.[index].price, siteSettingsData.CurrencyThousandsSeparator, siteSettingsData.CurrencyDecimalSeparator));
    const [updatedImage, setUpdatedImage] = useState([]);
    const [image, setImage] = useState("");

    const handleOpenSubChild = () => {
        setOpen(true);
    }

    const itemNumber = foodDetails?.group?.child?.[index].itemNumber ? foodDetails?.group?.child?.[index].itemNumber : foodDetails?.item?.child?.[index].itemNumber;

    useEffect(() => {
        try {
            let img =
                data.image !== ""
                    ? require("../../../assets/images/FoodImages/" + data.image)
                    : DummyFoodImage;
            setImage(img);
        }
        catch (e) {
            if (data.image) {
                API_CALLS.getFoodImageApiCall(
                    headersConfigData,
                    siteId.get(),
                    data.image
                )
                    .then(async (response) => {
                        const blob = await response.blob();  // Handle image as a blob
                        const image = URL.createObjectURL(blob);
                        setImage(image)
                    }
                    );
            }
            else
                setImage(DummyFoodImage);
        }
    }, [])

    useEffect(() => {
        if (listType === "group") {
            let temp = list;
            if (updatedImage && updatedImage.length > 0) {
                temp[parentIndex][i].group.child[index].image = updatedImage[0].key;
                try {
                    setImage(updatedImage[0].value);
                }
                catch (e) {
                    setImage(DummyFoodImage);
                }
                setList(temp);
            }
        }
        if (listType === "item") {
            let temp = list;
            if (updatedImage && updatedImage.length > 0) {
                temp[parentIndex][i].item.child[index].image = updatedImage[0].key;
                try {
                    setImage(updatedImage[0].value);
                }
                catch (e) {
                    setImage(DummyFoodImage);
                }
                setList(temp);
            }
        }
    }, [updatedImage]);

    useEffect(() => {
        try {
            let img = data.image !== ""
                ? require("../../../assets/images/FoodImages/" + data.image)
                : DummyFoodImage;
            setImage(img);
        }
        catch (e) {
            if (data.image) {
                API_CALLS.getFoodImageApiCall(
                    headersConfigData,
                    siteId.get(),
                    data.image
                )
                    .then(async (response) => {
                        const blob = await response.blob();  // Handle image as a blob
                        const image = URL.createObjectURL(blob);
                        setImage(image)
                    }
                    );
            }
            else
                setImage(DummyFoodImage);
        }
    }, [list]);

    const onChangeTitle = (e) => {
        handleOnChangeTitle(e, listType, "child", parentIndex, i, itemNumber, index, 0);
        setTitle(e.target.value);
    }

    const onChangePrice = (e) => {
        handleOnChangePrice(e, listType, "child", parentIndex, i, index, 0);
        setPrice(e.target.value);
    }

    return (
        <>
            {subChild && subChild.length > 0 ? (
                <Accordion expanded={expandSubGroup}>
                    <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={
                            <ExpandMoreNormalIcon
                                onClick={(e) =>
                                    toggleAcordionSubGroup(e, parentIndex, i, listType, index)
                                }
                            />
                        }
                    >
                        <ItemRow className="add-item-header">
                            <div className="input-section">
                                <div className="arrow-container">
                                    <Tooltip title={t("Move_up")}>
                                        <button>
                                            <ArrowUpwardIcon
                                                onClick={() =>
                                                    shiftUpDownChild(
                                                        parentIndex,
                                                        i,
                                                        index,
                                                        listType,
                                                        "UPARROW"
                                                    )
                                                }
                                            />
                                        </button>
                                    </Tooltip>
                                    <Tooltip title={t("Move_down")}>
                                        <button>
                                            <ArrowDownwardIcon
                                                onClick={() =>
                                                    shiftUpDownChild(
                                                        parentIndex,
                                                        i,
                                                        index,
                                                        listType,
                                                        "DOWNARROW"
                                                    )
                                                }
                                            />
                                        </button>
                                    </Tooltip>
                                </div>
                                <div className="food-img-wrapper" onClick={handleOpenSubChild}>
                                    <img src={image} alt="food-img" />
                                </div>
                                <input
                                    maxLength={30}
                                    value={title}
                                    onChange={(e) => onChangeTitle(e)
                                    }
                                />
                            </div>
                            <div className="price-input">
                                <span>{siteSettingsData.CurrencySymbol}</span>
                                <input
                                    maxLength={30}
                                    name="price"
                                    onMouseOut={(e) => setPrice(formatNumber(e.target.value, siteSettingsData.CurrencyThousandsSeparator, siteSettingsData.CurrencyDecimalSeparator))}
                                    placeholder={`0${siteSettingsData.CurrencyDecimalSeparator}00`}
                                    value={price}
                                    onChange={(e) => onChangePrice(e)}
                                />
                            </div>
                            <div className="action-wrapper">
                                {listType === "group" && (
                                    <Tooltip title={t("Add_option")}>
                                        <button
                                            className="add-btn"
                                            onClick={(e) => addSubchild(e, i, index, parentIndex)}
                                        >
                                            <AddIcon />
                                        </button>
                                    </Tooltip>
                                )}
                                <Tooltip title={t("Delete_item")}>
                                    <IconButton
                                        disabled={
                                            isUserBasic(getUserRole && getUserRole?.Role) ||
                                            isUserReadOnly(getUserRole && getUserRole?.Role)
                                        }
                                        aria-label="delete"
                                        onClick={(e) => handleOnDelete(i, index, listType, "child", title, parentIndex, null, e)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </ItemRow>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ItemsWrapper>
                            <GroupSubChildList
                                key={index}
                                subChild={subChild}
                                handleOnDeleteSubChild={handleOnDeleteSubChild}
                                i={i}
                                index={index}
                                DummyFoodImage={DummyFoodImage}
                                handleOnChangePrice={handleOnChangePrice}
                                shiftUpSubChild={shiftUpSubChild}
                                listType={listType}
                                itemNumber={itemNumber}
                                parentIndex={parentIndex}
                                handleOnChangeTitle={handleOnChangeTitle}
                                list={list}
                                setList={setList}
                            />
                        </ItemsWrapper>
                    </AccordionDetails>
                </Accordion>
            ) : (
                <ItemRow className="inner-item-row">
                    <div className="input-section">
                        <div className="arrow-container">
                            <Tooltip title={t("Move_up")}>
                                <button>
                                    <ArrowUpwardIcon
                                        onClick={() =>
                                            shiftUpDownChild(
                                                parentIndex,
                                                i,
                                                index,
                                                listType,
                                                "UPARROW"
                                            )
                                        }
                                    />
                                </button>
                            </Tooltip>
                            <Tooltip title={t("Move_down")}>
                                <button>
                                    <ArrowDownwardIcon
                                        onClick={() =>
                                            shiftUpDownChild(
                                                parentIndex,
                                                i,
                                                index,
                                                listType,
                                                "DOWNARROW"
                                            )
                                        }
                                    />
                                </button>
                            </Tooltip>
                        </div>
                        <div className="food-img-wrapper" onClick={handleOpenSubChild}>
                            <img src={image} alt="food-img" />
                        </div>
                        <input
                            maxLength={30}
                            value={title}
                            onChange={(e) => onChangeTitle(e)}
                        />
                    </div>
                    <div className="price-input">
                        <span>{siteSettingsData.CurrencySymbol}</span>
                        <input
                            maxLength={30}
                            name="amount"
                            placeholder={`0${siteSettingsData.CurrencyDecimalSeparator}00`}
                            onMouseOut={(e) => setPrice(formatNumber(e.target.value, siteSettingsData.CurrencyThousandsSeparator, siteSettingsData.CurrencyDecimalSeparator))}
                            value={price}
                            onChange={(e) => onChangePrice(e)}
                        />
                    </div>
                    <div className="action-wrapper">
                        {listType === "group" && (
                            <Tooltip title={t("Add_option")}>
                                <button
                                    className="add-btn"
                                    onClick={(e) => addSubchild(e, i, index, parentIndex)}
                                >
                                    <AddIcon />
                                </button>
                            </Tooltip>
                        )}
                        <Tooltip title={t("Delete_item")}>
                            <IconButton
                                disabled={
                                    isUserBasic(getUserRole && getUserRole?.Role) ||
                                    isUserReadOnly(getUserRole && getUserRole?.Role)
                                }
                                aria-label="delete"
                                onClick={(e) => handleOnDelete(i, index, listType, "child", title, parentIndex, itemNumber, e)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </ItemRow>
            )}

            {open && <FoodImagePopup
                open={open}
                setImage={setUpdatedImage}
                setOpen={setOpen}
                title={title}
                setIsSaveMenuDisabled={setIsSaveMenuDisabled}
            />}
        </>
    );
};
export default AddItem;

const GroupSubChildList = ({
    subChild,
    DummyFoodImage,
    handleOnDeleteSubChild,
    i,
    index,
    parentIndex,
    handleOnChangePrice,
    shiftUpSubChild,
    itemNumber,
    listType,
    handleOnChangeTitle,
    list,
    setList
}) => {
    const { t } = useTranslation();

    const { siteSettingsData, getUserRole } = useSelector((state) => state.commonReducers) || [];
    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const [openSubChild, setOpenSubChild] = useState([]);
    const [subChildAll, setSubChildAll] = useState([]);
    const [childListImage, setChildListImage] = useState(null);
    const [subChildIndexImg, setsubChildIndexImg] = useState(null);

    const handleOpenSubChild = (subChildIndex) => {
        openSubChild[subChildIndex] = true;
        setOpenSubChild([...openSubChild]);
    };

    const getImage = (image) => {
        let img;
        try {
            img = image ? require("../../../assets/images/FoodImages/" +
                image) : DummyFoodImage;
        } catch (error) {
            if (image) {
                API_CALLS.getFoodImageApiCall(
                    headersConfigData,
                    siteId.get(),
                    image
                )
                    .then(async (response) => {
                        const blob = await response.blob();  // Handle image as a blob
                        img = URL.createObjectURL(blob);
                    }
                    );
            }
            else
                img = DummyFoodImage;
        }
        return img;
    }

    useEffect(() => {
        let temp = list;
        if (childListImage) {
            temp[parentIndex][i]["group"]["child"][index]["subChild"][
                subChildIndexImg
            ].image = childListImage;
            setList([...temp]);
        } else if (childListImage === "") {
            temp[parentIndex][i]["group"]["child"][index]["subChild"][
                subChildIndexImg
            ].image = "";
            setList([...temp]);
        }
    }, [childListImage]);

    useEffect(() => {
        if (subChild.length > 0) {
            subChild.map((data, i) => (openSubChild[i] = false));
            setSubChildAll(subChild);
        }
    }, [subChild]);

    const handleMouseOut = (e) => {
        setSubChildAll((prevInputs) =>
            prevInputs && prevInputs.length > 0 && prevInputs.map((input) =>
                input.itemNumber === parseInt(e.target.name) ? { ...input, price: formatNumber(e.target.value, siteSettingsData.CurrencyThousandsSeparator, siteSettingsData.CurrencyDecimalSeparator) } : input
            )
        );
    }

    const onChangeTitle = (e, subChildIndex) => {
        handleOnChangeTitle(e, listType, "subChild", parentIndex, i, itemNumber, index, subChildIndex);
        setSubChildAll((prevInputs) =>
            prevInputs && prevInputs.length > 0 && prevInputs.map((input) =>
                input.itemNumber === parseInt(e.target.name) ? { ...input, title: e.target.value } : input
            )
        );
    }

    const onChangePrice = (e, subChildIndex) => {
        handleOnChangePrice(e, listType, "subChild", parentIndex, i, index, subChildIndex);
        setSubChildAll((prevInputs) =>
            prevInputs && prevInputs.length > 0 && prevInputs.map((input) =>
                input.itemNumber === parseInt(e.target.name) ? { ...input, price: e.target.value } : input
            )
        );
    }

    return (
        <>
            {subChildAll && subChildAll.length > 0 ? (
                subChildAll.map((subChild, subChildIndex) => (
                    <ItemRow className="inner-item-row" key={subChildIndex}>
                        <div className="input-section">
                            <div className="arrow-container">
                                <Tooltip title={t("Move_up")}>
                                    <button>
                                        <ArrowUpwardIcon
                                            onClick={() =>
                                                shiftUpSubChild(
                                                    parentIndex,
                                                    i,
                                                    index,
                                                    subChildIndex,
                                                    "UPARROW"
                                                )
                                            }
                                        />
                                    </button>
                                </Tooltip>
                                <Tooltip title={t("Move_down")}>
                                    <button>
                                        <ArrowDownwardIcon
                                            onClick={() =>
                                                shiftUpSubChild(
                                                    parentIndex,
                                                    i,
                                                    index,
                                                    subChildIndex,
                                                    "DOWNARROW"
                                                )
                                            }
                                        />
                                    </button>
                                </Tooltip>
                            </div>
                            <div
                                className="food-img-wrapper"
                                onClick={() => handleOpenSubChild(subChildIndex)}
                            >
                                <img src={getImage(subChild.image)} alt="food-img" />
                            </div>
                            <input
                                maxLength={30}
                                name={subChild.itemNumber}
                                value={subChild.title}
                                onChange={(e) => onChangeTitle(e, subChildIndex)}
                            />
                        </div>
                        <div className="price-input">
                            <span>{siteSettingsData.CurrencySymbol}</span>
                            <input
                                maxLength={30}
                                name={subChild.itemNumber}
                                placeholder={`0${siteSettingsData.CurrencyDecimalSeparator}00`}
                                onMouseOut={handleMouseOut}
                                value={subChild.price}
                                onChange={(e) => {
                                    onChangePrice(e, subChildIndex);
                                }}
                            />
                        </div>
                        <Tooltip title={t("Delete_item")} >
                            <div className="action-wrapper">
                                <IconButton
                                    disabled={
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    aria-label="delete"
                                    onClick={(e) => handleOnDeleteSubChild(i, index, subChildIndex, parentIndex, subChild.title, e)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        </Tooltip>
                        <FoodImagePopup
                            open={openSubChild[subChildIndex]}
                            setOpen={setOpenSubChild}
                            openSubChild={openSubChild}
                            subChildIndex={subChildIndex}
                            setChildListImage={setChildListImage}
                            setSubChildIndexImg={setsubChildIndexImg}
                            title={subChild.title}
                        />
                    </ItemRow>
                ))
            ) : (
                <></>
            )}
        </>
    );
};
